export default 'common';
